import React from "react";
import { List, Datagrid, TextField, DateField, FunctionField, useRedirect, TopToolbar, ExportButton, Button, SearchInput } from "react-admin";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { formatPhoneNumberStrict, formatPostalCode, getNameAndCompanyName, isOverdue } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const InspectList = () => {
  const redirect = useRedirect();

  const InspectActions = () => {    
    return (
      <TopToolbar>
        <Button label="顧客リスト" onClick={() => redirect(`/customers-inspect`)} ><SwapHorizIcon /></Button>
        <Button label="未収リスト" onClick={() => redirect(`/uncollect-inspect`)} ><SwapHorizIcon /></Button>
        <ExportButton exporter={customExporter}/>
      </TopToolbar>
    );
  };

  const CustomerFilters = [
    <SearchInput
      source="q" 
      alwaysOn 
      placeholder="郵便番号・住所・顧客名" 
      inputProps={{ style: { fontSize: '12px' } }} 
      sx={{ width: 250 }}
    />,
  ];

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => ({
  //     "顧客名":`${getNameAndCompanyName(record.surname,record.name,record.companyName)}`,// フルネーム結合
  //     "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //     "電話番号": `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`,
  //     "請求月": record.invoiceMonth ? `${record.invoiceMonth}月` : "",
  //     "点検月": record.checkMonth ? `${record.checkMonth.replaceAll("、", "・")}` : "",
  //     "最終清掃日": record.cleaningDate ? new Date(record.cleaningDate).toLocaleDateString() : "",
  //     "清掃予定日": record.exCleaningDate ? new Date(record.exCleaningDate).toLocaleDateString() : "",
  //     "規模": record.scale ?? "",
  //     "請求金額(税抜き)":record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}` : "",
  //     "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
  //     "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
  //     "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
  //     "領収": record.isPay ? "済" : ""
      
  //   }));
  
  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `点検リスト_` + new Date().toLocaleDateString());
  // };

const customExporter = (records) => {
  const excelData = records.map(record => ({
    "顧客名": `${getNameAndCompanyName(record.surname, record.name, record.companyName)}`, // フルネーム結合
    "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`,
    "電話番号": `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`,
    "請求月": record.invoiceMonth ? `${record.invoiceMonth}月` : "",
    "点検月": record.checkMonth ? `${record.checkMonth.replaceAll("、", "・")}` : "",
    "最終清掃日": record.cleaningDate ? new Date(record.cleaningDate).toLocaleDateString() : "",
    "清掃予定日": record.exCleaningDate ? new Date(record.exCleaningDate).toLocaleDateString() : "",
    "規模": record.scale ?? "",
    "請求金額(税抜き)": record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}` : "",
    "請求日": record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : "",
    "再発行日": record.reissueDate ? new Date(record.reissueDate).toLocaleDateString() : "",
    "領収日": record.receiptDate ? new Date(record.receiptDate).toLocaleDateString() : "",
    "領収": record.isPay ? "済" : ""
  }));

  // ワークシート作成
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // 列幅設定（文字数に合わせて調整）
  worksheet['!cols'] = [
    { wch: 25 }, // 顧客名
    { wch: 60 }, // 住所
    { wch: 18 }, // 電話番号
    { wch: 10 }, // 請求月
    { wch: 15 }, // 点検月
    { wch: 15 }, // 最終清掃日
    { wch: 15 }, // 清掃予定日
    { wch: 10 }, // 規模
    { wch: 18 }, // 請求金額(税抜き)
    { wch: 15 }, // 請求日
    { wch: 15 }, // 再発行日
    { wch: 15 }, // 領収日
    { wch: 10 }, // 領収
  ];

  // ワークブック作成
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, '点検リスト');

  // エクセルバッファを生成
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  // ファイル保存
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `点検リスト_${new Date().toLocaleDateString()}.xlsx`);
};


  const handleRowClick = (id, resource, record) => {
    const toPath = record.inspectId ? `/inspectHistory/show/${record.inspectId}` : `/customers-inspect/show/${record.customerId}`
    const url = `${window.location.origin}/#${toPath}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  return (
    <List actions={<InspectActions />} filters={CustomerFilters}>
      <Datagrid  bulkActionButtons={false} rowClick={(id, resource, record) => handleRowClick(id, resource, record)} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        <FunctionField
          label="顧客名"
          render={record => {
            return `${getNameAndCompanyName(record.surname,record.name,record.companyName)}`;
          }}
        />
        <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField
          source="phone"
          label="電話番号"
          render={(record) => `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`}
        />
        <FunctionField
          label="請求月" 
          render={(record) => `${record.invoiceMonth ? `${record.invoiceMonth}月` : ""}`}
        />
        <FunctionField source="checkMonth" label="点検月" 
          render={record => {
            return `${record.checkMonth ? record.checkMonth.replaceAll("、", "・") : ""}`;
          }}
        />
        <DateField source="cleaningDate" label="最終清掃日" />
        <DateField source="exCleaningDate" label="清掃予定日" />
        <TextField source="scale" label="規模" />
        <FunctionField source="invoiceAmount" label="請求金額(税抜き)"
          render={(record) => {
            return record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}円` : ""
          }}
        />
        <DateField source="invoiceDate" label="請求日" />
        <DateField source="reissueDate" label="再発行日" />
        <DateField source="receiptDate" label="領収日" />
        <FunctionField
          label="領収"
          render={record => {
            return `${record.isPay ? "済" : ""}`;
          }}
        />
        

      </Datagrid>
    </List>
  );
};

export default InspectList;
